const routes = {
  countdown: '/countdown',
  root: '/',
  login: '/login',
  reset: '/reset-password',
  createPassword: '/create-password',
  personal: '/personal',
  profile: '/personal/profile',
  editProfile: '/personal/update',

  sessions: '/sessions',
  liveSessions: '/sessions/live-sessions',
  keynote: '/sessions/live-sessions/keynote',
  masterclass: '/sessions/live-sessions/masterclass',
  specialPresentation: '/sessions/live-sessions/special-presentation',
  otherSession: '/sessions/live-sessions/other-sessions',

  onDemand: '/on-demand',
  onDemandSessions: '/on-demand/sessions',

  odKeynote: '/on-demand/keynote',
  odMasterclass: '/on-demand/masterclass',
  odSpecialPresentation: '/on-demand/special-presentation',
  odOtherSession: '/on-demand/other-sessions',

  onDemandShow: '/on-demand/sessions/:id',

  recordedSessions: '/sessions/recorded-sessions',
  recordedSessionsAccess: '/sessions/recorded-sessions/:id',

  networking: '/networking',

  welcome: '/sessions/welcome',
  toc: '/toc',
  privacypolicy: '/privacypolicy',

  zoom: '/zoom',
  joinSession: '/join-session',
  leaveSession: '/leave-session',
}

export const externalRoutes = {
  resetPassword: 'https://registration.lesa2023.asb.edu.my/password/new',
  passPdf: 'https://registration.lesa2023.asb.edu.my/my-access-pass',
  dashboard: 'https://registration.lesa2023.asb.edu.my/users/dashboard',
}

export const dynamicRoutes = {
  joinZoom: (sessionId) => `/join-zoom/${sessionId}`,
}

export default routes
